import { render, staticRenderFns } from "./activities-skeleton.vue?vue&type=template&id=75ebd649&scoped=true"
import script from "./activities-skeleton.vue?vue&type=script&lang=js"
export * from "./activities-skeleton.vue?vue&type=script&lang=js"
import style0 from "./activities-skeleton.vue?vue&type=style&index=0&id=75ebd649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ebd649",
  null
  
)

export default component.exports